@if (_totals.ui + _totals.wifi > 0) {
  <app-firmware-distribution [totals]="_totals" [chartDataUi]="_chartDataUi"
                             [chartDataWifi]="_chartDataWifi"></app-firmware-distribution>
} @else {
  <div class="w-100">
    <h2 class="text-center">No thing in group</h2>
  </div>
}
